import React from 'react';
import SuperAdminLayout from '../../components/admin/SuperAdminLayout';
import SystemOverview from '../../components/admin/SystemOverview';

const AdminOverviewPage: React.FC = () => {
  return (
    <SuperAdminLayout>
      <SystemOverview />
    </SuperAdminLayout>
  );
};

export default AdminOverviewPage;